import type { SvgIconComponent } from '@mui/icons-material';
import AccountCircleOutlinedIcon from '@mui/icons-material/AccountCircleOutlined';
import AssessmentOutlinedIcon from '@mui/icons-material/AssessmentOutlined';
import DarkModeOutlinedIcon from '@mui/icons-material/DarkModeOutlined';
import LanguageOutlinedIcon from '@mui/icons-material/LanguageOutlined';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import Inventory2OutlinedIcon from '@mui/icons-material/Inventory2Outlined';
import MarkEmailReadOutlinedIcon from '@mui/icons-material/MarkEmailReadOutlined';
import MenuBookOutlinedIcon from '@mui/icons-material/MenuBookOutlined';
import NotificationsOutlinedIcon from '@mui/icons-material/NotificationsOutlined';
import PlaylistAddOutlinedIcon from '@mui/icons-material/PlaylistAddOutlined';
import ToggleOnOutlinedIcon from '@mui/icons-material/ToggleOnOutlined';
import ReceiptLongOutlinedIcon from '@mui/icons-material/ReceiptLongOutlined';
import SearchOutlinedIcon from '@mui/icons-material/SearchOutlined';
import AddCircleOutlineOutlinedIcon from '@mui/icons-material/AddCircleOutlineOutlined';
import TableRowsOutlinedIcon from '@mui/icons-material/TableRowsOutlined';
import SummarizeOutlinedIcon from '@mui/icons-material/SummarizeOutlined';
import WarningAmberOutlinedIcon from '@mui/icons-material/WarningAmberOutlined';

const KNOWLEDGE_ARTICLE_ICONS: Record<string, SvgIconComponent> = {
  supply: Inventory2OutlinedIcon,
  'supply-overview': Inventory2OutlinedIcon,
  'supply-material-lines': PlaylistAddOutlinedIcon,
  'supply-accepts-extra': ToggleOnOutlinedIcon,
  dashboard: AssessmentOutlinedIcon,
  'dashboard-overview': AssessmentOutlinedIcon,
  'dashboard-fulfillment-status': WarningAmberOutlinedIcon,
  'dashboard-empty-state': InfoOutlinedIcon,
  orders: ReceiptLongOutlinedIcon,
  'orders-overview': ReceiptLongOutlinedIcon,
  'orders-summary': SummarizeOutlinedIcon,
  'orders-search-filter': SearchOutlinedIcon,
  'orders-create': AddCircleOutlineOutlinedIcon,
  'orders-table': TableRowsOutlinedIcon,
  notifications: NotificationsOutlinedIcon,
  'notification-page': NotificationsOutlinedIcon,
  'mark-notifications-read': MarkEmailReadOutlinedIcon,
  'account-settings': AccountCircleOutlinedIcon,
  'change-language': LanguageOutlinedIcon,
  'appearance-theme': DarkModeOutlinedIcon,
};

export const getKnowledgeArticleIcon = (articleId: string): SvgIconComponent =>
  KNOWLEDGE_ARTICLE_ICONS[articleId] ?? MenuBookOutlinedIcon;
